import Constants from "../../Action/Constants";
import { ActionInterface } from "../../Interface/ActionInterface";

interface StateInterface {
  isFetching: boolean;
  fields: string[];
  translatedMessage: string;
  isDialogOpen: boolean;
  isUpdating: boolean;
  chargeTemplates: any[];
  contractIdHasUpdatedCharges: number;
}

const initialState: StateInterface = {
  isFetching: false,
  fields: [],
  translatedMessage: "",
  isDialogOpen: false,
  isUpdating: false,
  chargeTemplates: [],
  contractIdHasUpdatedCharges: null
};

export const contractUpdateReducer = (state: StateInterface = initialState, action: ActionInterface): StateInterface => {
  switch (action.type) {
    case Constants.PAGE_CONTRACT_UPDATE_HAS_CHARGES_CHANGES:
      return {
        ...state,
        contractIdHasUpdatedCharges: action?.payload?.contractId
      };

    case Constants.PAGE_CONTRACT_UPDATE_REQUEST:
      return {
        ...state,
        isFetching: true
      };

    case Constants.PAGE_CONTRACT_UPDATE_SUCCESS:
      return {
        ...state,
        isFetching: false
      };

    case Constants.PAGE_CONTRACT_UPDATE_FAILURE:
      return {
        ...state,
        isFetching: false,
        fields: action.payload?.err.fields || [],
        translatedMessage: action.payload?.err.translatedMessage
      };

    case Constants.GLOBAL_CHARGE_TEMPLATE_CREATE_SUCCESS:
      return {
        ...state,
        chargeTemplates: state.chargeTemplates.some(chargeTemplate => chargeTemplate.id === action.payload?.chargeTemplate.id) ?
        [
          action.payload?.chargeTemplate,
          ...state.chargeTemplates.filter(chargeTemplate => chargeTemplate.id !== action.payload?.chargeTemplate.id)
        ] : [action.payload?.chargeTemplate, ...state.chargeTemplates]
      };

    case Constants.GLOBAL_CHARGE_TEMPLATE_DELETE_SUCCESS:
      return {
        ...state,
        chargeTemplates: [
          ...state.chargeTemplates.filter(chargeTemplate => chargeTemplate.id !== action.payload?.chargeTemplate.id)
        ]
      };

    case Constants.GLOBAL_CHARGE_TEMPLATE_CREATE_FAILURE:
      return {
        ...state,
        fields: action.payload?.err.fields || [],
        translatedMessage: action.payload?.err.translatedMessage
      };

    case Constants.GLOBAL_CHARGE_TEMPLATE_UPDATE_FAILURE:
      return {
        ...state,
        fields: action.payload?.err.fields || [],
        translatedMessage: action.payload?.err.translatedMessage
      };

    case Constants.GLOBAL_AGENCY_FEE_CREATE_FAILURE:
      return {
        ...state,
        fields: action.payload?.err.fields || [],
        translatedMessage: action.payload?.err.translatedMessage
      };

    case Constants.GLOBAL_AGENCY_FEE_UPDATE_FAILURE:
      return {
        ...state,
        fields: action.payload?.err.fields || [],
        translatedMessage: action.payload?.err.translatedMessage
      };

    case Constants.PAGE_CONTRACT_UPDATE_ERRORS_CLEAR:
      return {
        ...state,
        fields: []
      };

    
    case Constants.PAGE_CONTACT_PERSON_CREATE_FAILURE:
      return {
        ...state,
        isFetching: false,
        fields: action.payload?.err.fields || [],
        translatedMessage: action.payload?.err.translatedMessage,
      };
  
  
    case Constants.PAGE_CONTACT_COMPANY_CREATE_FAILURE:
      return {
        ...state,
        isFetching: false,
        fields: action.payload?.err.fields || [],
        translatedMessage: action.payload?.err.translatedMessage,
      };
      
    case Constants.COACH_ERRORS_CLEAR:
      return {
        ...initialState
      };  

    case Constants.GLOBAL_CHARGE_TYPE_CREATE_FAILURE:
      return {
        ...state,
       // isFetching: false,
        fields: action.payload?.err.fields || [],
        translatedMessage: action.payload?.err.translatedMessage
      };
      
    case Constants.GLOBAL_CHARGE_TEMPLATE_CREATE_CLEAR:
    case Constants.GLOBAL_CHARGE_TEMPLATE_UPDATE_CLEAR:
    case Constants.PAGE_CONTRACT_UPDATE_CLEAR:
    case Constants.GLOBAL_CHARGE_TYPE_CREATE_CLEAR:
    case Constants.AUTH_SIGNOUT:
      return {
        ...initialState
      };

    default:
      return state;
  }
};
